



















































































































































import {
  defineComponent, reactive, ref, Ref, onMounted, watch, computed,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import _ from 'lodash';

import {
  updatePurchaseOrderFill,
  receivePurchaseRequest,
  getPurchaseRequestItems,
  searchPurchaseRequestItems,
  getJobs,
} from '@/api/index';

import purchaseRequestItems from '@/table/PurchaseRequest/receive-purchase-request-item';
import purchaseRequestItemWithAmountTableOption from '@/table/PurchaseRequest/receive-purchase-request-item-with-amount';
import usePurchaseRequest from '@/use/usePurchaseRequest';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const NOW = useFormat.date().computerShortDate();

const ReceiveMaterial = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const { classMap: statusClassMap, translate: statusTranslate } = usePurchaseRequest();
    const step = ref(1);
    const refetchQuery = ref(false);
    const confirmModal = ref(null);
    const purchaseRequestTableData = ref({ total: 0, data: [] });
    const forceRender = ref(false);
    const filter = reactive({
      filterBomId: '',
      filterBomCode: '',
    });
    const form = reactive({
      type: '',
      status: 'PENDING',
      invoice: '',
      items: [],
      miscItems: [],
      remarks: '',
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          await receivePurchaseRequest(computedReceiveInput.value as any);
        }
        (confirmModal.value as any).compose({ action: 'รับของ' });
      },
      state: {
        value: 'READY',
      },
    });
    const computedReceiveInput = computed(() => ({
      items: form.items.map((item: any) => ({
        id: item.id,
        receive_amount: item.amount,
      })),
    }));

    onMounted(async () => {
      await handleInstanceSearchQuery();
    });

    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== purchaseRequestTableData.value.total) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = purchaseRequestTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Condition to check form is valid
    const allowedToSubmit = computed(() => {
      const pricePerUnitsArr = form.items.map((item: any) => parseInt(item.pricePerUnit, 10));
      if (pricePerUnitsArr.indexOf(0) > -1) return false;
      const amounts = form.items.map((item: any) => parseInt(item.amount, 10));
      if (amounts.indexOf(0) > -1) return false;
      return true;
    });

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 30;
    const receivePurchaseRequestPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form.items.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
      totalPages: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
    }));
    async function forward() {
      const result = await searchPurchaseRequestItems({ ids: searchValue.value, filterReceivable: true });
      form.items = result.map((item: any) => ({
        ...item,
        neededAmount: item.amount,
        amount: parseFloat(`${(item.amount - item.receive_amount) > -1 ? (item.amount - item.receive_amount) : 0}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        purchaseUnit: item.bom_item.material?.default_purchase_unit || item.bom_item.material?.unit,
      }));
      step.value = 2;
    }
    async function backward() {
      step.value = 1;
    }
    const displayData = computed(() => {
      if ((form.items as any).length < receivePurchaseRequestPaginator.value.to) return (form.items as any).slice(receivePurchaseRequestPaginator.value.from, (form.items as any).length);
      return (form.items as any).slice(receivePurchaseRequestPaginator.value.from, receivePurchaseRequestPaginator.value.to);
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receivePurchaseRequestData(data: any) {
      purchaseRequestTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    // Handle "instantSearch" if redirect from PanelWithPurchaseOrderItemTable component
    async function handleInstanceSearchQuery() {
      if (route.value.query.instantSearch) {
        if (route.value.query.instantSearch === 'string' && route.value.query.instantSearch !== 'ALL') {
          selectedItemId.value = [parseInt(route.value.query.instantSearch, 10)];
          searchValue.value = [parseInt(route.value.query.instantSearch, 10)];
        } else if (!Array.isArray(route.value.query.instantSearch)) {
          selectedItemId.value = [route.value.query.instantSearch];
          searchValue.value = [route.value.query.instantSearch];
        } else {
          selectedItemId.value = route.value.query.instantSearch;
          searchValue.value = route.value.query.instantSearch;
        }
        await forward();
      }
    }

    return {
      NOW,
      toDate,

      forceRender,
      confirmModal,
      step,
      forward,
      backward,

      refetchQuery,
      selectItem,
      selectedItemId,
      searchValue,

      clearSelect,
      selectAll,
      form,
      allowedToSubmit,

      displayData,
      page,
      pagination: receivePurchaseRequestPaginator,
      getPurchaseRequestItems,
      purchaseRequestItems,
      purchaseRequestItemWithAmountTableOption,

      receivePurchaseRequestData,

      statusClassMap,
      statusTranslate,

      getJobs,
      filter,
      refetchQueryHandler,
    };
  },
});

export default ReceiveMaterial;
